export const PricingTierType = {
  fixed: {
    name: 'Fixed',
    code: '00',
  },
  variable: {
    name: 'Variable',
    code: '01',
  },
};
